module.exports = __webpack_public_path__ + "img/about_banner.2ec1dc87.png";